module.exports = __webpack_public_path__ + "static/media/phia.b1b202de.jpg";